/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useDispatch, useSelector } from 'react-redux';

import {
    getPageAccountInfoUrl,
    isPageAccountInfoUrlExternal,
} from '../../../../../pages/PageAccountInfo';
import { openExternalRoute } from '../../../../../routes/constants/externalRoutes';
import { ELogBusinessEventName, ELogBusinessEventType, logBusinessEvent } from '../../../../logging';
import { makeSelectGuardComponents } from '../../../../role';
import { ITableLinkProps } from './types';

export const useTableCellAccount = (id: string, value: string): ITableLinkProps => {

    const dispatch = useDispatch();
    const componentsFeature = useSelector(makeSelectGuardComponents());

    const onClick = () => {
        dispatch(logBusinessEvent({
            eventName: ELogBusinessEventName.USER_ACCOUNT,
            type: ELogBusinessEventType.common,
        }));
        if (isPageAccountInfoUrlExternal(componentsFeature)) {
            openExternalRoute(getPageAccountInfoUrl(componentsFeature, id));
        }
    };

    return {
        isExternalUrl: isPageAccountInfoUrlExternal(componentsFeature),
        url: getPageAccountInfoUrl(componentsFeature, id),
        onClick,
        children: value,

        noValue: !id || !value,
    }
}
